var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("filter",null,{"bus":_vm.bus,"current":_vm.current}),_vm._v(" "),_c('div',{staticClass:"grid",attrs:{"id":_vm.id}},[_vm._t("list",null,{"imageCallback":_vm.imageCallback})],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }